import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../../css/documentation2.css';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { useParams } from 'react-router-dom';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import { APP_VERSION } from '../../constants';

const Documentation = () => {
  const [reportData, setReportData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { category_id } = useParams();
  const token = getToken();
  const companyName = decodeToken(token, 'companyName');
  const companyLogo = decodeToken(token, 'logo');

  useEffect(() => {
    const fetchReportData = async () => {
      axios
        .get(`${API_URL}/${ENDPOINTS.SYS}/documentation2/${category_id}`, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        })
        .then((response) => {
          console.log(response.data);
          //  console.log('fields:', response.data.fields);
          setReportData(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching user guide data:', error);
          setLoading(false);
        });
    };

    fetchReportData();
  }, []);

  if (loading) {
    return <p>Loading report documentation...</p>;
  }

  if (error) {
    return <p>Error fetching report data: {error}</p>;
  }

  if (Object.keys(reportData).length === 0) {
    return <p>No data available.</p>;
  }

  // Function to render parameters for a single route
  const renderParameters = (parameters) => {
    if (parameters.length === 0) return null; // Skip if no parameters

    return (
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Label</th>
            {/* <th>Default Value</th> */}
            <th>Datatype</th>
            <th>Options</th>

            <th>Is Required</th>
            {/* <th>Allowed Extensions</th>
            <th>Max Size</th> */}
          </tr>
        </thead>
        <tbody>
          {parameters.map((param, index) => (
            <tr key={index}>
              <td>{param.label}</td>
              {/* <td>{param.default_value}</td> */}
              <td>{param.type}</td>
              <td>{param.options}</td>

              <td>{param.is_required ? 'Required' : 'Optional'}</td>
              {/* <td>{param.allowed_extensions}</td>
              <td>{param.max_size}</td> */}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  // const renderFilteringDescription = (params) => {
  //   let filtersDocumentation = '';

  //   params.forEach((param) => {
  //     // Handle enum or enum-dropdown types with options
  //     if (param.type === 'enum' || param.type === 'enum-dropdown') {
  //       filtersDocumentation += `
  //         <p>
  //           <strong>${param.label} Filter:</strong> Allows users to filter the
  //           report by specific options. Available options:
  //         </p>
  //         <ul>
  //           ${
  //             param.options &&
  //             param.options
  //               .split(',')
  //               .map((option) => `<li>${option}</li>`)
  //               .join('')
  //           }
  //         </ul>
  //       `;
  //     }
  //     // If both 'from' and 'to' are present, display a combined date range filter description
  //     if (param.name === 'from') {
  //       filtersDocumentation += `
  //         <p>
  //           <strong>Date Range Filter:</strong> Allows users to filter the
  //           report by a specific range of dates. Please specify the date range:
  //         </p>
  //         <ul>
  //           <li>From: Start date</li>

  //         </ul>
  //       `;
  //     }
  //     // If both 'from' and 'to' are present, display a combined date range filter description
  //     if (param.name === 'to') {
  //       filtersDocumentation += `

  //         <ul>
  //           <li>To: End date</li>

  //         </ul>
  //       `;
  //     }
  //     // For other filters, add a default description
  //     else {
  //       filtersDocumentation += `
  //         <p>
  //           <strong>${param.label} Filter:</strong> Allows users to filter the
  //           report by ${param.label.toLowerCase()}.
  //         </p>
  //       `;
  //     }
  //   });

  //   return <div dangerouslySetInnerHTML={{ __html: filtersDocumentation }} />;
  // };

  let fromTo = 'Not Used';
  const renderFilteringDescription = (param) => {
    // Handle enum or enum-dropdown types with options
    if (param.type === 'enum' || param.type === 'enum-dropdown') {
      return (
        <>
          <p>
            <strong>{param.label} Filter:</strong> Allows users to filter the
            report by specific options. Available options:
          </p>
          <ul>
            {param.options &&
              param.options
                .split(',')
                .map((option, idx) => <li key={idx}>{option}</li>)}
          </ul>
        </>
      );
    }
    // If both 'from' and 'to' are present, display a combined date range filter description
    if (
      (param.name === 'from' || param.name === 'to') &&
      fromTo === 'Not Used'
    ) {
      //  console.log(param.name);
      delete param.to; // Replace 'key' with the actual key you want to remove

      fromTo = 'Used';
      return (
        <>
          <p>
            <strong>Date Range Filter:</strong> Allows users to filter the
            report by a specific range of dates. Please specify the date range:
          </p>
          <ul>
            <li>From: Start date</li>
            <li>To: End date</li>
          </ul>
        </>
      );
    }

    return (
      <>
        <p>
          <strong>{param.label} Filter:</strong> Allows users to filter the
          report by {param.label.toLowerCase()}.
        </p>
      </>
    );
  };

  //console.log('reportData:', reportData);
  return (
    <div className="documentation-container">
      <div className="text-center" style={{ marginTop: '20px' }}>
        <img
          src={`${API_URL}/${companyLogo}`}
          alt={companyName}
          className="rounded-circle"
        />

        <h1 className="title">{companyName}</h1>
        <br />
        <h3>System Documentation</h3>

        <h6>Version: {APP_VERSION}</h6>
        <br />

        <h5>Powered by Kaafiye Technology Center</h5>
      </div>
      {reportData &&
        Object.keys(reportData).map((category) => (
          <div key={category} className="category-section">
            <h2>{category} Module</h2>
            <p>{reportData[category][0].category_description}</p>
            <br />
            <h4>{category} Module's Features</h4>
            <ul className="list-group">
              {reportData[category].map((report, index) => (
                <li key={index} className="list-group-item">
                  {report.form_serial}. {report.form_name}
                </li>
              ))}
            </ul>

            {reportData[category].map((report, index) => {
              report.parameters = report.parameters.filter(
                (param) => param.name !== 'to'
              );
              report.parameters = report.parameters.filter(
                (param) => param.type !== 'hidden'
              );
              report.parameters = report.parameters.filter(
                (param) => param.type !== 'hidden-user'
              );

              // console.log('report:', report);
              return (
                <div key={index} className="report-card">
                  <h3>
                    {report.form_serial}. {report.form_name}
                  </h3>
                  <p>
                    <strong></strong> {report.description}
                  </p>

                  {/* Table Fields Header */}
                  {(report.form_type === 'report' ||
                    report.form_type === 'form-report') && (
                    <div>
                      <h4>Report Columns:</h4>
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            {report.fields ? (
                              report.fields
                                .filter(
                                  (field) =>
                                    !/(replace|public|ktc_update|')/i.test(
                                      field
                                    )
                                ) // Exclude fields containing any of these substrings
                                .map((field, idx) => (
                                  <th key={idx}>
                                    {field.replace('`', '').replace('`', '')}
                                  </th>
                                ))
                            ) : (
                              <th>No fields found</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {/* Body can be filled with sample data or left as a placeholder */}
                          <tr>
                            {report.fields ? (
                              report.fields
                                .filter(
                                  (field) =>
                                    !/(replace|public|ktc_update|')/i.test(
                                      field
                                    )
                                ) // Exclude fields containing any of these substrings
                                .map((field, idx) => <th key={idx}>{'-'}</th>)
                            ) : (
                              <th>No fields found</th>
                            )}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                  {(report.form_type === 'report' ||
                    report.form_type === 'form-report') &&
                    report.parameters?.length > 0 && (
                      <div>
                        <h4>Filtering Options:</h4>
                        <div className="filter-options">
                          {report.parameters.map((param, indx) =>
                            renderFilteringDescription(param)
                          )}
                        </div>
                      </div>
                    )}

                  {(report.form_type === 'reg-modal' ||
                    report.form_type === 'reg-upload-modal') && (
                    <div>
                      <h4>Form Fields:</h4>
                      {renderParameters(report.parameters)}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}
    </div>
  );
};

export default Documentation;
